export default __webpack_public_path__ + "static/media/svsfl.771257e3.jpg";